import BaseService from "./BaseService";

class IntegrationService {
  static async list(data) {
    const params = BaseService.cleanQueryParams(data);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `/v1/enterprise/integrations?${queryParams}`
    );
  }

  static async create(data) {
    return await BaseService.callAPI(
      `/v1/enterprise/integrations`,
      "POST",
      data
    );
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/v1/enterprise/integrations/${id}`);
  }

  static async update(data) {
    return await BaseService.callAPI(
      `/v1/enterprise/integrations/${data.id}`,
      "PUT",
      data
    );
  }

  static async delete({ id }) {
    return await BaseService.callAPI(
      `/v1/enterprise/integrations/${id}`,
      "DELETE"
    );
  }

  static async getSubtypes({ type, subtype }) {
    return await BaseService.callAPI(
      `/v1/enterprise/integrations/type/${type}/subtype/${subtype}`,
      "GET"
    );
  }
}

export default IntegrationService;
